
    import * as React from 'react';

    const ShippingAlt16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M13.772 5.496L11.43 4.81 5.692 6.676l2.163.726 5.917-1.906zm1.226-.395H15v5.273L7.85 13 1 10.37V5.1l.006.002L1 5.08 7.852 3 15 5.094l-.002.007zm-12.836.39l2.379.798 5.64-1.845-2.325-.681L2.162 5.49zM7.48 8.054L1.7 6.126v3.75l5.78 2.22V8.055zm.75.003v4.044l6.07-2.23V6.12L8.23 8.058z" /></svg>
        </div>
      );
    };

    ShippingAlt16.displayName = 'ShippingAlt16';

    export default ShippingAlt16;
  